import { useCallback, useState } from "react";
import type { Editor } from "grapesjs";

const downloadTextFile = (filename: string, content: string, mime: string) => {
    const blob = new Blob([content], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};

export function useHtmlPreview(editorRef: React.RefObject<Editor>, projectName: string) {
    const [showHTMLModal, setShowHTMLModal] = useState(false);
    const [generatedHTML, setGeneratedHTML] = useState("");

    const openHTMLPreview = useCallback(() => {
        const editor = editorRef.current;
        if (!editor) return;

        const html = editor.getHtml();
        setGeneratedHTML(html);
        setShowHTMLModal(true);
    }, [editorRef]);

    const closeHTMLPreview = useCallback(() => setShowHTMLModal(false), []);

    const downloadHTML = useCallback(() => {
        if (!generatedHTML) return;
        downloadTextFile(`${projectName}.html`, generatedHTML, "text/html");
    }, [generatedHTML, projectName]);

    const copyHTML = useCallback(() => {
        if (!generatedHTML) return;
        navigator.clipboard?.writeText?.(generatedHTML).catch(console.error);
    }, [generatedHTML]);

    return { showHTMLModal, generatedHTML, openHTMLPreview, closeHTMLPreview, downloadHTML, copyHTML };
}
